<template>
<div class="chapter">
<div class="inner_page">
<p class="copyj" id="page1">Helion &amp; Company Limited</p>
<p class="copy">Unit 8 Amherst Business Centre</p>
<p class="copy">Budbrooke Road</p>
<p class="copy">Warwick</p>
<p class="copy">CV34 5WE</p>
<p class="copy">England</p>
<p class="copy">Tel. 01926 499 619</p>
<p class="copy">Fax 0121 711 4075</p>
<p class="copy">Email: <span class="weblink"><span class="underline"><a href="mailto:info@helion.co.uk">info@helion.co.uk</a></span></span></p>
<p class="copy">Website: <span class="weblink"><span class="underline"><a href="http://www.helion.co.uk" target="_blank">www.helion.co.uk</a></span></span></p>
<p class="copy">Twitter: <span class="weblink"><span class="underline"><a href="http://www.twitter.comhelionbooks" target="_blank">@helionbooks</a></span></span></p>
<p class="copy">Visit our blog <span class="weblink"><span class="underline"><a href="http://blog.helion.co.uk/" target="_blank">http://blog.helion.co.uk/</a></span></span></p>
<p class="copy1">Published by Helion &amp; Company 2018</p>
<p class="copy">Designed and typeset by Farr out Publications, Wokingham, Berkshire</p>
<p class="copy">Cover designed by Paul Hewitt, Battlefield Design (<span class="weblink"><span class="underline"><a href="http://www.battlefield-design.co.uk" target="_blank">www.battlefield-design.co.uk</a></span></span>)</p>
<p class="copy1">Text © David François 2018</p>
<p class="copy">Illustrations © as individually credited</p>
<p class="copy">Color profiles and maps as credited © Helion &amp; Company Limited 2018</p>
<p class="copy0a">Every reasonable effort has been made to trace copyright holders and to obtain their permission for the use of copyright material. The author and publisher apologize for any errors or omissions in this work, and would be grateful if notified of any corrections that should be incorporated in future reprints or editions of this book.</p>
<p class="copy1">ISBN 978-1-911628-21-7</p>
<p class="copy">eISBN 978-1-91311-841-9</p>
<p class="copy1">British Library Cataloguing-in-Publication Data</p>
<p class="copy">A catalogue record for this book is available from the British Library</p>
<p class="copy0a">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form, or by any means, electronic, mechanical, photocopying, recording or otherwise, without the express written consent of Helion &amp; Company Limited.</p>
<p class="copy0a">We always welcome receiving book proposals from prospective authors.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Copyright.vue?02825f43